import { cumulativeVerifiedEmission } from "./emission.js";
import { nativeAmount } from "./types.js";
import { CURRENT_CONTRACT_VERSION, protocolRules } from "./protocolRules.js";
export const FUEL_PERIOD_SECONDS = 10n * 86400n;
export const MAX_FUEL_PERIODS = 3;
export const X3_FUEL_SURCHARGE = nativeAmount(20000000000000000n);
export function fuelNativePayment(targetMultiplier, version = CURRENT_CONTRACT_VERSION) {
    return nativeAmount(targetMultiplier === 3 ? protocolRules(version).x3Surcharge : 0n);
}
export function quoteFuelBurn(input) {
    if (input.verifiedTotalWeight <= 0n)
        throw new RangeError("Verified weight must be positive");
    if (!Number.isInteger(input.periods) || input.periods < 1 || input.periods > MAX_FUEL_PERIODS)
        throw new RangeError("Fuel periods must be between one and three");
    if ((input.contractVersion ?? CURRENT_CONTRACT_VERSION) !== "legacy-v3") {
        const currentExpiry = input.currentExpiry ?? 0n;
        if (input.upgradingFromTwo && input.targetMultiplier !== 3)
            throw new RangeError("An upgrade must target x3");
        if (input.upgradingFromTwo && currentExpiry <= input.timestamp)
            throw new RangeError("x3 requires active x2 Fuel");
        const start = input.upgradingFromTwo
            ? input.timestamp
            : currentExpiry > input.timestamp
                ? currentExpiry
                : input.timestamp;
        const end = input.upgradingFromTwo
            ? currentExpiry
            : start + BigInt(input.periods) * FUEL_PERIOD_SECONDS;
        if (!input.upgradingFromTwo && end - input.timestamp > 3n * FUEL_PERIOD_SECONDS + 3600n)
            throw new RangeError("Fuel prepayment exceeds 30 days");
        const emission = cumulativeVerifiedEmission(input.emissionStart, end) -
            cumulativeVerifiedEmission(input.emissionStart, start);
        return ((emission * (input.upgradingFromTwo ? 7n : input.targetMultiplier === 2 ? 5n : 12n)) /
            (10n * input.verifiedTotalWeight));
    }
    const futureVerified = cumulativeVerifiedEmission(input.emissionStart, input.timestamp + FUEL_PERIOD_SECONDS) -
        cumulativeVerifiedEmission(input.emissionStart, input.timestamp);
    const oneWeightEmission = futureVerified / input.verifiedTotalWeight;
    if (input.upgradingFromTwo)
        return (oneWeightEmission * 7n) / 10n;
    const onePeriod = input.targetMultiplier === 2 ? (oneWeightEmission * 5n) / 10n : (oneWeightEmission * 12n) / 10n;
    return onePeriod * BigInt(input.periods);
}
//# sourceMappingURL=fuel.js.map